//
// Composant qui fait la sidebar de droite pour éditer une sortie
//

<template>
    <div>
        <h2 class="title">{{config.data.label}}</h2>
        <form @submit.prevent="validate" @input="saveIt">

            <h2 class="is-size-5" v-if="config.type==='TASK'">Label</h2>
            <h2 class="is-size-5" v-if="config.type==='DIAL'">Réponse</h2>

            <b-input v-model="config.data.label" size="is-small" ref="startFocus"></b-input>
            <h2 class="is-size-5">Couleur</h2>

            <div class="columns is-gapless">
                <div class="column">
                    <color-picker-board :default-color="getColor"
                                        :width="150"
                                        :height="30"
                                        @onSelection="colorSelection"></color-picker-board>
                    <div>
                        <palette v-for="(value) in getStoreColors" :key="value" :color="value" @onSelection="colorSelection"></palette>
                    </div>
                </div>

                <div class="column">
                    <b-input v-model="config.data.color" size="is-small" ref="mycolor" expanded></b-input>
                </div>
            </div>
            <hr>
            <h2 class="is-size-5"  v-if="config.type==='TASK'">SI :</h2>
            <h2 class="is-size-5"  v-if="config.type==='DIAL'">Cette réponse est proposée SI :</h2>

                <carac v-for="(value,key,index) in getCond"
                       :key="value.clef" :objet="value" letype="COND" :lieu="config.id"
                       @deleteMe="delCond" @reloadMe="reloadMe"></carac>

                <b-collapse :open="false" aria-id="contentIdForA11y1" ref="addcondition" @open="focusCondOn"  @close="focusCondOff">
                    <b-button
                            size="is-small"
                            type="is-info"
                            slot="trigger"
                            aria-controls="contentIdForA11y1">
                        <b-icon  icon="plus"></b-icon>
                    </b-button>
                    <div>
                        <Addcarac :lieu="config.id" @validated="addCond" :open="condIsOpen" letype="COND"></Addcarac>
                    </div>
                </b-collapse>
            <hr>
            <h2 class="is-size-5" v-if="config.type==='TASK'">ALORS :</h2>
            <h2 class="is-size-5" v-if="config.type==='DIAL'">En choisissant cette réponse ALORS :</h2>

                <carac v-for="(value,key,index) in getCons"
                       :key="value.clef" :objet="value" letype="CONS" :lieu="config.id"
                       @deleteMe="delCons" @reloadMe="reloadMe"></carac>

            <b-collapse :open="false" aria-id="contentIdForA11y2" ref="addconsequence" @open="focusConsOn"  @close="focusConsOff">
                <b-button
                        size="is-small"
                        type="is-info"
                        slot="trigger"
                        aria-controls="contentIdForA11y2">
                    <b-icon  icon="plus"></b-icon>
                </b-button>
                <div>
                    <Addcarac :lieu="config.id" @validated="addCons" :open="consIsOpen"  letype="CONS"></Addcarac>
                </div>
            </b-collapse>
            <hr>
            <h2 class="is-size-5">META DONNEES :</h2>

            <carac v-for="(value,key,index) in getMeta"
                   :key="value.clef" :objet="value"  letype="META" :lieu="config.id"
                   @deleteMe="delMeta" @reloadMe="reloadMe"></carac>

            <b-collapse :open="false" aria-id="contentIdForA11y3" ref="addmeta" @open="focusMetaOn"  @close="focusMetaOff">
                <b-button
                        size="is-small"
                        type="is-info"
                        slot="trigger"
                        aria-controls="contentIdForA11y3">
                    <b-icon  icon="plus"></b-icon>
                </b-button>
                <div>
                    <Addcarac :lieu="config.id" @validated="addMeta" :open="metaIsOpen"  letype="META"></Addcarac>
                </div>
            </b-collapse>
        </form>

    </div>
</template>

<script>

    import Carac from './Carac.vue';
    import Palette from './Palette.vue';
    import Addcarac from './AddCarac.vue';
    import _ from 'lodash';
    import VueColorPickerBoard from 'vue-color-picker-board';

    export default {
        name: 'tabltask',
        data (){
            return {
                condIsOpen:false,
                consIsOpen:false,
                metaIsOpen:false,
            }
        },
        components: {
            Carac,
            Palette,
            Addcarac,
            'color-picker-board':VueColorPickerBoard
        },
        props: ['config'],
        computed: {

            getCond(){
                return this.config.data.condition
            },
            getCons(){
                return this.config.data.consequence
            },
            getMeta(){
                return this.config.data.meta
            },

            getColor(){
                return this.config.data.color
            },
            getStoreColors(){
                return this.$store.getters.getColorUsed
            }
        },
        methods: {

            async reloadMe(){
                // ya un truc qui a changé ailleur, te casse pas, reload le resultat
                const newVersion=await this.$mydb.do.getResultat(this.config.id)

                //scrountch
                this.config.data=newVersion.data
            },

            saveIt: _.debounce(function (){
                this.validate()
            }, 2000),

            colorSelection(evt){
                this.config.data.color=evt
                this.validate()
                this.$refs.mycolor.focus()
            },

            async validate()
            {
                //this.$notification.open('SAUVEGARDE!!')
                //update le db
                await this.$mydb.do.updateResultat(this.config)

                //Update le couleur des lien si besoin
                this.$store.commit('UPDATELINK_COLOR',this.config);
                this.$store.commit('UPDATELINK_LABEL',this.config);



            },

            async deleteResultat(){
                try {
                    //del dans la base
                    await this.$mydb.do.deleteResultat(this.config);

                    //del des liens dans le store
                    this.$store.commit('DELETE_RESULTAT',this.config.id);

                    //Attention : tordu : Il faut que Tache.vue recharge les data de la base, donc il faut lui faire emettre un evenement
                    this.config.data.reload=1

                    //switch sidebar
                    const toEdit={
                        name:'TabHelp',
                        config:''
                    }
                    this.$store.commit('DROITE_SET',toEdit);
                }
                catch(e) {
                    console.log("Erreur:" + e)
                }
            },

            async addCond(carac){
                const done=await this.$mydb.do.saveCarac(carac)

                //clef unique donc gestion d'une erreur de promesse rejettée
                if(done){
                    this.config.data.condition.push(carac.clef)
                }
                else {
                    this.alertCustomError("ERREUR ! <br>Cette clef existe déjà pour cet élément précis...")
                }
               this.$refs.addcondition.toggle()
            },
            delCond(evt){
                this.config.data.condition=this.config.data.condition.filter( thing => (thing !== evt ))
                this.saveIt()

            },
            async addCons(carac){
                const done=await this.$mydb.do.saveCarac(carac)

                //clef unique donc gestion d'une erreur de promesse rejettée
                if(done){
                    this.config.data.consequence.push(carac.clef)
                }
                else {
                    this.alertCustomError("ERREUR ! <br>Cette clef existe déjà pour cet élément précis...")
                }
                this.$refs.addconsequence.toggle()
            },
            delCons(evt){
                this.config.data.consequence=this.config.data.consequence.filter( thing => (thing !== evt ))
                this.saveIt()

            },
            async addMeta(carac){
                const done=await this.$mydb.do.saveCarac(carac)

                //clef unique donc gestion d'une erreur de promesse rejettée
                if(done){
                    this.config.data.meta.push(carac.clef)
                }
                else {
                    this.alertCustomError("ERREUR ! <br>Cette clef existe déjà pour cet élément précis...")
                }
                this.$refs.addmeta.toggle()
            },
            delMeta(evt){
                this.config.data.meta=this.config.data.meta.filter( thing => (thing !== evt ))
                this.saveIt()

            },

            //**********************************************************
            // DIFFERENTES ALERTES
            //**********************************************************
            alertCustomError(msg) {
                this.$dialog.alert({
                    title: 'Error',
                    message: msg,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle-outline',
                    iconPack: 'mdi'
                })
            },

            focusCondOn() {
                this.condIsOpen=true
            },
            focusCondOff() {
                this.condIsOpen=false
            },
            focusConsOn() {
                this.consIsOpen=true
            },
            focusConsOff() {
                this.consIsOpen=false
            },
            focusMetaOn() {
                this.metaIsOpen=true
            },
            focusMetaOff() {
                this.metaIsOpen=false
            }

        },
        mounted(){

            this.$refs.startFocus.focus()
            //console.log(this.config)
        },
        watch: {

        }

    }


</script>


<style lang="scss" scoped>
    hr{
        margin:2px !important;
    }
    color-picker{
        display:block !important;
    }
    mapalette{
        width:150px;
        height:auto;
        display:block !important;
    }
    .BTNadd{

    }
</style>